const appDomain = (import.meta.env.VITE_LOGIN_URL ?? '').replace('/login', '');

const FIQ_UTM_PARAMS = {
  utm_source: 'c2fo',
  utm_medium: 'in_app',
  utm_campaign: 'financeiq',
  utm_series: 'ent-fiq-homepage-widget',
} as const;

/**
 * Builds a fully-qualified FinanceIQ URL with standard widget UTM params appended.
 * @param subPath - Path within the FinanceIQ app, e.g. '/', '/cashflow-manager', '/insights/uuid/invoices'
 * @param routeParams - Additional query params specific to the destination (merged before UTMs)
 */
export const createFiqUrl = (subPath: string, routeParams?: Record<string, string>): string => {
  const params = new URLSearchParams({ ...routeParams, ...FIQ_UTM_PARAMS });
  return `${appDomain}/financeiq${subPath}?${params.toString()}`;
};
